module.exports = __webpack_public_path__ + "static/img/bg_1.0ff24714.png";